var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66668 7.99999C2.66668 8.36818 2.96515 8.66666 3.33334 8.66666L11.0572 8.66666L7.52861 12.1953C7.26826 12.4556 7.26826 12.8777 7.52861 13.1381C7.78896 13.3984 8.21106 13.3984 8.47141 13.1381L13.1376 8.47188M11.0572 7.33332L3.33334 7.33332C2.96515 7.33332 2.66668 7.6318 2.66668 7.99999M13.2828 7.7448C13.2502 7.66617 13.202 7.5925 13.1381 7.52858L8.47142 2.86192C8.21107 2.60157 7.78896 2.60157 7.52861 2.86192C7.26826 3.12227 7.26826 3.54438 7.52861 3.80473L11.0572 7.33332M13.2828 8.25518C13.3154 8.17657 13.3333 8.09038 13.3333 7.99999C13.3333 7.9096 13.3154 7.82341 13.2828 7.7448M13.2828 8.25518C13.251 8.33202 13.2042 8.40413 13.1424 8.46702L13.2828 8.25518Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "arrowRight",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 12,
    height: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 8.66668C2.96516 8.66668 2.66668 8.3682 2.66668 8.00001C2.66668 7.63182 2.96516 7.33334 3.33335 7.33334L12.6667 7.33334C13.0349 7.33334 13.3333 7.63182 13.3333 8.00001C13.3333 8.3682 13.0349 8.66668 12.6667 8.66668L3.33335 8.66668Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrowRight)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 16,
    height: 16,
    transform: "rotate(90 16 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.64573703fa5729cd596fecef194e8a02.svg";
export { ForwardRef as ReactComponent };